export const fontClasses = {
  inter: "font-[var(--font-inter)]",
  spartan: "font-[var(--font-spartan)]",
} as const;
